export default __webpack_public_path__ + "static/media/logo6.6827f456.png";